<mat-form-field appearance="outline">
  <input
    type="text"
    matInput
    [formControl]="formControl"
    [matAutocomplete]="autoGroup"
    [placeholder]="placeholder"
    [attr.data-cy]="E2eLocators.CONTROLS_ADDRESS_AUTOCOMPLITE_INPUT"
  />
  <mat-autocomplete
    #autoGroup="matAutocomplete"
    autoActiveFirstOption
    [displayWith]="getAddressLabel.bind(this)"
    (optionSelected)="showClear = true"
  >
    @for (group of autocompleteState | async; track trackGroup($index, group)) { @if (!!group.label)
    {
    <mat-optgroup [label]="group.label | pluralAddressType" class="mat-opt-group-title">
      @for (address of group.addresses; track trackAddress($index, address)) {
      <mat-option
        [value]="{ address: address, groupLabel: group.label }"
        [attr.data-cy]="E2eLocators.CONTROLS_ADDRESS_AUTOCOMPLITE_OPTION"
      >
        <span class="onsip-disable-clicktocall">{{ address.name }}</span>
      </mat-option>
      }
    </mat-optgroup>
    } @if (!group.label) { @for (address of group.addresses; track trackAddress($index, address)) {
    <mat-option
      [value]="{ address: address, groupLabel: group.label }"
      [attr.data-cy]="E2eLocators.CONTROLS_ADDRESS_AUTOCOMPLITE_OPTION"
    >
      <span class="onsip-disable-clicktocall">{{ address.name }}</span>
    </mat-option>
    } } }
  </mat-autocomplete>
  @if (!showClear) {
  <mat-icon matSuffix color="primary">search</mat-icon>
  } @if (showClear) {
  <button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="handleClear()">
    <mat-icon color="primary">close</mat-icon>
  </button>
  }
  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>
